import api from "../services/api";

export const getFunnel = async (days = 30) => (await api.get('/admin/funnel', { params: { days } })).data;
export const getFunnelSteps = async (days = 30) => (await api.get('/admin/funnel/steps', { params: { days } })).data;
export const getFeedback = async (type) => (await api.get('/admin/feedback', { params: type ? { type } : {} })).data;
export const setFeedbackStatus = async (id, status) => (await api.put(`/admin/feedback/${id}`, { status })).data;
